export default __webpack_public_path__ + "static/media/jubilee-logo-red.8e7808b6.png";